import { marker as _ } from '@colsen1991/ngx-translate-extract-marker';

import { BescheidLoadPhase } from '../enums/bescheid-load-phase.enum';
import { LoadState } from '../enums/load-state.enum';

/**
 * Translation keys per phase.
 *
 * Kept in one place so app and portal show the same text and a renamed key does not have to be
 * followed up in two spots. The marker has to be named `_`, because `extract-translations:*` runs
 * with `-m _` and would not find these keys otherwise — they appear in no template.
 */
export const BESCHEID_LOAD_PHASE_KEYS: Record<BescheidLoadPhase, string> = {
  [BescheidLoadPhase.Downloading]: _('waiting_text.downloading'),
  [BescheidLoadPhase.Decrypting]: _('waiting_text.decrypting'),
  [BescheidLoadPhase.Extracting]: _('waiting_text.extracting'),
};

/** Key for the percentage readout; expects the `percent` parameter. */
export const BESCHEID_LOAD_PERCENT_KEY = _('waiting_text.percent_loaded');

/** A file from the unpacked container, not yet prepared for any specific view. */
export interface LoadedFile {
  name: string;
  data: Uint8Array<ArrayBuffer>;
}

export interface BescheidLoadProgress {
  state: LoadState.Loading;
  phase: BescheidLoadPhase;
  /** Percentage of the download, or `null` while the total size is unknown. */
  percent: number | null;
}

export interface BescheidLoadComplete {
  state: LoadState.Done;
  files: LoadedFile[];
}

/**
 * The load as a stream: any number of {@link BescheidLoadProgress}, followed by exactly one
 * {@link BescheidLoadComplete}. Tell them apart with `isComplete`.
 */
export type BescheidLoad = BescheidLoadProgress | BescheidLoadComplete;
